import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import type { Resource } from 'i18next';
import { DEFAULT_LANGUAGE, I18N_NAMESPACES, SUPPORTED_LANGUAGES } from '@/i18n/settings';

import enCommon from '@/i18n/locales/en/common.json';
import enHome from '@/i18n/locales/en/home.json';
import enTrackOrder from '@/i18n/locales/en/trackOrder.json';

import hiCommon from '@/i18n/locales/hi/common.json';
import hiHome from '@/i18n/locales/hi/home.json';
import hiTrackOrder from '@/i18n/locales/hi/trackOrder.json';

import guCommon from '@/i18n/locales/gu/common.json';
import guHome from '@/i18n/locales/gu/home.json';
import guTrackOrder from '@/i18n/locales/gu/trackOrder.json';

import mrCommon from '@/i18n/locales/mr/common.json';
import mrHome from '@/i18n/locales/mr/home.json';
import mrTrackOrder from '@/i18n/locales/mr/trackOrder.json';

import knCommon from '@/i18n/locales/kn/common.json';
import knHome from '@/i18n/locales/kn/home.json';
import knTrackOrder from '@/i18n/locales/kn/trackOrder.json';

import taCommon from '@/i18n/locales/ta/common.json';
import taHome from '@/i18n/locales/ta/home.json';
import taTrackOrder from '@/i18n/locales/ta/trackOrder.json';

import teCommon from '@/i18n/locales/te/common.json';
import teHome from '@/i18n/locales/te/home.json';
import teTrackOrder from '@/i18n/locales/te/trackOrder.json';

import bnCommon from '@/i18n/locales/bn/common.json';
import bnHome from '@/i18n/locales/bn/home.json';
import bnTrackOrder from '@/i18n/locales/bn/trackOrder.json';

const resources: Resource = {
  en: { common: enCommon, home: enHome, trackOrder: enTrackOrder },
  hi: { common: hiCommon, home: hiHome, trackOrder: hiTrackOrder },
  gu: { common: guCommon, home: guHome, trackOrder: guTrackOrder },
  mr: { common: mrCommon, home: mrHome, trackOrder: mrTrackOrder },
  kn: { common: knCommon, home: knHome, trackOrder: knTrackOrder },
  ta: { common: taCommon, home: taHome, trackOrder: taTrackOrder },
  te: { common: teCommon, home: teHome, trackOrder: teTrackOrder },
  bn: { common: bnCommon, home: bnHome, trackOrder: bnTrackOrder },
};

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: DEFAULT_LANGUAGE,
      supportedLngs: [...SUPPORTED_LANGUAGES],
      ns: [...I18N_NAMESPACES],
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        caches: ['localStorage'],
      },
    });
}

export default i18n;
